// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"361":"6dfd49ec","547":"66bfa742","594":"ad94b0fd","648":"83fca5e1"}[chunkId] + ".js";
};